import {
  useFormikContext,
  FormikContextType,
  getIn,
  FormikValues,
  FormikErrors,
  FormikTouched,
  FieldMetaProps,
} from 'formik';

const getMetaProperties = (
  values: FormikValues,
  errors: FormikErrors<FormikValues>,
  touched: FormikTouched<FormikValues>,
  initialTouched: FormikTouched<FormikValues>,
  initialErrors: FormikErrors<FormikValues>,
  initialValues: FormikValues,
  name: string
) => ({
  error: getIn(errors, name),
  touched: getIn(touched, name),
  initialTouched: getIn(initialTouched, name),
  value: getIn(values, name),
  initialError: getIn(initialErrors, name),
  initialValue: getIn(initialValues, name),
});

const generateMeta = ({
  error,
  initialError,
  touched,
  initialTouched,
  value,
  initialValue,
}: FieldMetaProps<FormikValues>) => ({
  error,
  touched,
  value,
  initialError,
  initialValue,
  initialTouched,
});

function useGenerateFieldMeta(fieldName: string) {
  const {
    values,
    errors,
    touched,
    initialErrors,
    initialTouched,
    initialValues,
  }: FormikContextType<FormikValues> = useFormikContext();

  const fieldMeta = generateMeta(
    getMetaProperties(
      values,
      errors,
      touched,
      initialTouched,
      initialErrors,
      initialValues,
      fieldName
    )
  );

  return fieldMeta;
}

export default useGenerateFieldMeta;
